var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50002 5.02002H21.5C21.7651 5.02002 21.98 5.45878 21.98 6.00002C21.98 6.54126 21.7651 6.98002 21.5 6.98002H2.50002C2.23492 6.98002 2.02002 6.54126 2.02002 6.00002C2.02002 5.45878 2.23492 5.02002 2.50002 5.02002ZM21.5 11.5199H2.50002C2.23492 11.5199 2.02002 11.9587 2.02002 12.4999C2.02002 13.0411 2.23492 13.4799 2.50002 13.4799H21.5C21.7651 13.4799 21.98 13.0411 21.98 12.4999C21.98 11.9587 21.7651 11.5199 21.5 11.5199ZM21.5 18.0201H2.50002C2.23492 18.0201 2.02002 18.4589 2.02002 19.0001C2.02002 19.5414 2.23492 19.9801 2.50002 19.9801H21.5C21.7651 19.9801 21.98 19.5414 21.98 19.0001C21.98 18.4589 21.7651 18.0201 21.5 18.0201Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10988_55704",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 20,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50002 5.02002H21.5C21.7651 5.02002 21.98 5.23492 21.98 5.50002C21.98 5.76512 21.7651 5.98002 21.5 5.98002H2.50002C2.23492 5.98002 2.02002 5.76512 2.02002 5.50002C2.02002 5.23492 2.23492 5.02002 2.50002 5.02002ZM21.5 11.5199H2.50002C2.23492 11.5199 2.02002 11.7348 2.02002 11.9999C2.02002 12.265 2.23492 12.4799 2.50002 12.4799H21.5C21.7651 12.4799 21.98 12.265 21.98 11.9999C21.98 11.7348 21.7651 11.5199 21.5 11.5199ZM21.5 18.0201H2.50002C2.23492 18.0201 2.02002 18.235 2.02002 18.5001C2.02002 18.7652 2.23492 18.9801 2.50002 18.9801H21.5C21.7651 18.9801 21.98 18.7652 21.98 18.5001C21.98 18.235 21.7651 18.0201 21.5 18.0201Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10988_55704)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "#393949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/HamburgerIcon.8e42f8b809a6f4746c69f429596fdbdb.svg";
export { ForwardRef as ReactComponent };